const FALLBACK_SEASON_START = '2025-07-01';
const FALLBACK_SEASON = '2025-26';
const EARLIEST_SEASON_START_YEAR = 2016;

interface SeasonOption {
  id: string
  name: string
}

function parseLocalDate(date: Date | string): Date {
  if (date instanceof Date) {
    return date;
  }

  const [ year, month, day ] = date.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function getSeasonStartDate() {
  return globalThis.window?.curtisCalendar?.seasonStart || FALLBACK_SEASON_START;
}

export function getConfiguredSeason() {
  const [ startYear ] = getSeasonStartDate().split('-').map(Number);

  if (isNaN(startYear)) {
    return FALLBACK_SEASON;
  }

  return `${startYear}-${(startYear + 1).toString().slice(-2)}`;
}

export function getSeason(date: Date | string) {
  const dateObj = parseLocalDate(date);
  const startDateStr = getSeasonStartDate();
  const [ , startMonthStr ] = startDateStr.split('-').map(Number);
  const startMonth = startMonthStr - 1;

  if (isNaN(startMonth)) {
    return FALLBACK_SEASON;
  }

  const currentMonth = dateObj.getMonth();
  const year = dateObj.getFullYear();

  if (currentMonth < startMonth) {
    return `${year - 1}-${year.toString().slice(-2)}`;
  }

  return `${year}-${(year + 1).toString().slice(-2)}`;
}

export function getSeasonOptions(currentSeason = getConfiguredSeason()): SeasonOption[] {
  const currentStartYear = Number(currentSeason.split('-')[0]);

  if (isNaN(currentStartYear)) {
    return [ { id: FALLBACK_SEASON, name: FALLBACK_SEASON } ];
  }

  const seasons: SeasonOption[] = [];

  for (let year = currentStartYear; year >= EARLIEST_SEASON_START_YEAR; year--) {
    const season = `${year}-${(year + 1).toString().slice(-2)}`;
    seasons.push({ id: season, name: season });
  }

  return seasons;
}
